import { NgModule } from '@angular/core';
import { BaseTimeRecordingsListComponent } from './_components/list/base-time-recordings-list.component';
import { BaseSharedModule } from '../../shared/base-shared.module';
import { AppsSharedModule } from '../../apps-shared/apps-shared.module';
import { BaseTimeRecordingsSearchExportComponent } from './_components/search-bar/base-time-recordings-search-export.component';
import { BaseTimeRecordingsFiltersComponent } from './_components/filters/base-time-recordings-filters.component';
import { BaseTimeRecordingsListItemComponent } from './_components/list-item/base-time-recordings-list-item.component';
import { BaseTimeRecordingsListHeadlineComponent } from './_components/list-headline/base-time-recordings-list-headline.component';
import { BaseEditTimeRecordModalComponent } from './_components/base-edit-time-record-modal/base-edit-time-record-modal.component';
import { BaseRecordStateComponent } from './_components/record-state/base-record-state.component';
import { BaseAssignmentDateAbsenceReasonTooltipComponent } from './_components/base-assignment-date-absence-reason-tooltip/base-assignment-date-absence-reason-tooltip.component';
import { BaseTimeRecordCorrectedInfoRowComponent } from './_components/base-time-record-corrected-info-row/base-time-record-corrected-info-row.component';
import { BaseTimeRecordAbsenceFormComponent } from './_components/base-time-record-absence-form/base-time-record-absence-form.component';
import { BaseTimeRecordFormComponent } from './_components/base-time-record-form/base-time-record-form.component';
import { BaseAddTimeRecordModalComponent } from './_components/base-add-time-record-modal/base-add-time-record-modal.component';
import { BaseAddEditTimeRecordModalFooterComponent } from './_components/base-add-edit-time-record-modal-footer/base-add-edit-time-record-modal-footer.component';
import { BaseAddAbsenceModalComponent } from './_components/base-add-absence-modal/base-add-absence-modal.component';
import { BaseCancelAssignmentDaysFormComponent } from './_components/base-cancel-assignment-days-form/base-cancel-assignment-days-form.component';
import { BaseTimeRecordTimestampsComponent } from './_components/base-time-record-timestamps/base-time-record-timestamps.component';
import { BaseTimeRecordRoundingSummaryComponent } from './_components/base-time-record-rounding-summary/base-time-record-rounding-summary.component';

@NgModule({
  imports: [BaseSharedModule, AppsSharedModule],
  declarations: [
    BaseTimeRecordingsListComponent,
    BaseTimeRecordingsSearchExportComponent,
    BaseTimeRecordingsFiltersComponent,
    BaseTimeRecordingsListItemComponent,
    BaseTimeRecordingsListHeadlineComponent,
    BaseEditTimeRecordModalComponent,
    BaseRecordStateComponent,
    BaseAssignmentDateAbsenceReasonTooltipComponent,
    BaseTimeRecordCorrectedInfoRowComponent,
    BaseTimeRecordAbsenceFormComponent,
    BaseTimeRecordFormComponent,
    BaseAddTimeRecordModalComponent,
    BaseAddEditTimeRecordModalFooterComponent,
    BaseAddAbsenceModalComponent,
    BaseCancelAssignmentDaysFormComponent,
    BaseTimeRecordTimestampsComponent,
    BaseTimeRecordRoundingSummaryComponent,
  ],
  exports: [BaseTimeRecordingsListComponent, BaseEditTimeRecordModalComponent, BaseCancelAssignmentDaysFormComponent],
})
export class BaseTimeRecordingsModule {}
